<template>
  <div>
    <v-select
      v-model="newValue"
      :items="workspaces"
      label="Workspaces"
      item-text="name"
      item-value="code"
      color="blue"
      item-color="info"
      menu-props="light"
      clearable
      :item-disabled="isDisabled"
      :rules="[(v) => (!!v && v.length > 0) || 'Required']"
      hide-details
      multiple
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

// eslint-disable-next-line no-undef
const props = defineProps({ value: { type: [Array], default: () => [] } });

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

// Vuex store
const store = useStore();

// Data
const newValue = ref(props.value);

// Computed
const workspaces = computed(() => store.getters.liveWorkspaces.filter(w => w.code !== 'merch'));

const selectedWorkspaceConfig = computed(() => (newValue.value && newValue.value.length
  ? workspaces.value.find(w => newValue.value[0] === w.code)
  : null));

// Methods
const isDisabled = val => val && selectedWorkspaceConfig.value && val?.settings?.merch?.type !== selectedWorkspaceConfig.value?.settings?.merch?.type;

// Watchers
watch(
  newValue,
  val => {
    emit('input', val || null);
  },
  { deep: true }
);

</script>

<style></style>
